var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0604 11.7578L11.6367 8H8.03128V5.5625C8.03128 4.5342 8.534 3.53125 10.1489 3.53125H11.7891V0.332031C11.7891 0.332031 10.3012 0.078125 8.87931 0.078125C5.90865 0.078125 3.96878 1.8783 3.96878 5.13594V8H0.667969V11.7578H3.96878V20.8426C4.63145 20.9467 5.3094 21 6.00003 21C6.69065 21 7.3686 20.9467 8.03128 20.8426V11.7578H11.0604Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbVector);
export default __webpack_public_path__ + "static/media/fbVector.59855db7adf3c9658ca1aaccb77538da.svg";
export { ForwardRef as ReactComponent };